/** Build Spotify embed iframe `src` from a normal open.spotify.com URL. */
export function spotifyEmbedSrc(url: string | null | undefined): string | null {
  if (!url) return null
  const m = url.match(/open\.spotify\.com\/(intl-[a-z]{2}\/)?(track|album|playlist|artist)\/([a-zA-Z0-9]+)/)
  if (!m) return null
  const kind = m[2]
  const id = m[3]
  return `https://open.spotify.com/embed/${kind}/${id}?utm_source=generator`
}
